// Recently Viewed Products in Search Dropdown (Returning Customers) — mobile only
(function () {
  "use strict";

  // The search dropdown markup renders once per breakpoint (mobile + desktop), so this
  // script tag is present twice on the page. Only the first instance should run.
  if (window.__cSearch48Initialized) return;
  window.__cSearch48Initialized = true;

  var STORAGE_KEY = "recentlyViewedProduct-" + (window.theme && window.theme.enviroment);
  var rendered = false;
  var pending = false;

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value || "";
    return div.innerHTML;
  }

  function getCurrentProductHandle(wrappers) {
    for (var i = 0; i < wrappers.length; i++) {
      var handle = wrappers[i].getAttribute("data-c-search48-current-handle");
      if (handle) return handle;
    }
    return "";
  }

  function getRecentlyViewedHandles(currentHandle) {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    try {
      var handles = JSON.parse(raw);
      if (currentHandle) {
        handles = handles.filter(function (handle) {
          return handle !== currentHandle;
        });
      }
      return handles.slice(0, 4);
    } catch (e) {
      return [];
    }
  }

  function cropImage(url) {
    if (!url) return "";
    var ext = /[^.]+$/.exec(url);
    return ext ? url.replace("." + ext[0], "_300x300_crop_center." + ext[0]) : url;
  }

  function getAddToCartVariant(product) {
    var variants = product.variants || [];
    return variants.filter(function (variant) {
      return variant.available;
    })[0] || variants[0];
  }

  function buildPriceHtml(product) {
    var html = "";
    if (product.compare_at_price && product.compare_at_price > product.price) {
      html +=
        '<span class="c-search48-price-compare">' +
        window.theme.money.format(product.compare_at_price) +
        "</span>";
    }
    html +=
      '<span class="c-search48-price-current">' + window.theme.money.format(product.price) + "</span>";
    return html;
  }

  function buildCardHtml(product) {
    var variant = getAddToCartVariant(product);
    if (!variant) return "";

    var image = product.featured_image
      ? '<img src="' +
        cropImage(product.featured_image) +
        '" alt="' +
        escapeHtml(product.title) +
        '" loading="lazy" class="c-search48-image">'
      : "";

    return window.templateSearch48Card
      .replaceAll("{{productUrl}}", product.url)
      .replaceAll("{{productImage}}", image)
      .replaceAll("{{productVendor}}", escapeHtml(product.vendor))
      .replaceAll("{{productTitle}}", escapeHtml(product.title))
      .replaceAll("{{productPrice}}", buildPriceHtml(product))
      .replaceAll("{{productHandle}}", product.handle)
      .replaceAll("{{variantId}}", variant.id);
  }

  function addToCart(button) {
    var variantId = button.getAttribute("data-variant-id");
    var textEl = button.querySelector(".c-search48-atc-text");
    if (!variantId || button.classList.contains("c-search48-disabled")) return;

    button.classList.add("c-search48-disabled");
    var originalText = textEl.textContent;
    textEl.textContent = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to add product to cart");
        textEl.textContent = "Added";
        button.classList.remove("c-search48-disabled");
        document.dispatchEvent(new CustomEvent("cart:updated"));
        window.dispatchEvent(new CustomEvent("cart:refresh"));
        setTimeout(function () {
          textEl.textContent = originalText;
        }, 2000);
      })
      .catch(function (error) {
        console.error("Error adding recently viewed product to cart:", error);
        textEl.textContent = "Error";
        button.classList.remove("c-search48-disabled");
        setTimeout(function () {
          textEl.textContent = originalText;
        }, 2000);
      });
  }

  function initAtcEvents(grid) {
    grid.addEventListener("click", function (event) {
      var button = event.target.closest("[data-c-search48-atc]");
      if (button) addToCart(button);
    });
  }

  function renderRecentlyViewed() {
    if (rendered || pending) return;

    var wrappers = document.querySelectorAll("[data-c-search48-wrapper]");
    if (!wrappers.length) return;

    var currentHandle = getCurrentProductHandle(wrappers);
    var handles = getRecentlyViewedHandles(currentHandle);
    if (!handles.length) return;

    pending = true;

    Promise.all(
      handles.map(function (handle) {
        return window.theme.product.loadProduct(handle).catch(function () {
          return null;
        });
      })
    ).then(function (products) {
      pending = false;
      var html = products.filter(Boolean).map(buildCardHtml).join("");
      // No usable product data yet (e.g. transient fetch failure) — leave `rendered`
      // false so a later open/focus/ig:ready retries instead of locking out forever.
      if (!html) return;

      rendered = true;

      // Mobile and desktop search dropdowns each render their own copy of this markup.
      wrappers.forEach(function (wrapper) {
        var grid = wrapper.querySelector("[data-c-search48-grid]");
        if (!grid) return;
        grid.innerHTML = html;
        wrapper.classList.add("c-search48-visible");
        initAtcEvents(grid);
      });
    });
  }

  function initQueryToggle() {
    document.querySelectorAll("[data-search-input]").forEach(function (input) {
      input.addEventListener("input", function () {
        var hasQuery = input.value.trim().length > 0;
        document.querySelectorAll("[data-c-search48-wrapper]").forEach(function (wrapper) {
          wrapper.classList.toggle("c-search48-query-active", hasQuery);
        });
      });
    });
  }

  function initOpenTriggers() {
    document.querySelectorAll("[data-search-open]").forEach(function (trigger) {
      trigger.addEventListener("click", renderRecentlyViewed);
    });
    document.querySelectorAll("[data-search-input]").forEach(function (input) {
      input.addEventListener("focus", renderRecentlyViewed);
      // Fallback for Safari: search-bar's own open() can throw before it reaches its
      // programmatic .focus() call, so "focus" never fires there. A direct click on the
      // input still dispatches normally regardless of that unrelated failure.
      input.addEventListener("click", renderRecentlyViewed);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initOpenTriggers();
    initQueryToggle();
  });
})();
